import React from 'react';
import { Link } from 'react-router-dom';
import '../../assets/styles/callToActionBanner.scss';

export type CallToActionBannerProps = {
  title: string;
  description?: string;
  buttonText: string;
  buttonLink: string;
  backgroundColor?: string;
  titleColor?: string;
  descriptionColor?: string;
  buttonColor?: string;
};

const CallToActionBanner: React.FC<CallToActionBannerProps> = ({
  title,
  description,
  buttonText,
  buttonLink,
  backgroundColor = '#f5f5f7',
  titleColor = '#1a1a1a',
  descriptionColor = '#666',
  buttonColor = '#9c27b0',
}) => {
  const styleVars = {
    '--cta-bg': backgroundColor,
    '--cta-title-color': titleColor,
    '--cta-desc-color': descriptionColor,
    '--cta-button-color': buttonColor,
  } as React.CSSProperties;

  return (
    <section className="cta-banner" style={styleVars}>
      <div className="cta-container">
        <div className="cta-content">
          <div className="cta-text">
            <h2 className="cta-title">{title}</h2>
            {description && <p className="cta-description">{description}</p>}
          </div>
          <Link to={buttonLink} className="cta-button">
            {buttonText}
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CallToActionBanner;
